// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import BackdropProgress from '../../../BackdropProgress';
import CircularProgress from '@mui/material/CircularProgress';
import CustomSnackbar from '../../ui/Snackbars';
import Grid from '@mui/material/Grid'
import no_image_availiable from '../../../images/no_image_available.jpeg';
import Paper from '@mui/material/Paper';
import React from 'react';
import useHttp from '../../../utils/http';
import wso2Theme from '../../../theme';
import { adjustForTimezone, getCountryNameFromCountryCode, getDateForDB, imageContentToImage } from '../../../utils/formatting';
import { getEmployeeOwnTravelDocumentImage } from '../../../utils/end-points.js';
import { getTravelDocumentStatusColor } from '../../../theme/status-colors';
import { useState, useEffect, useCallback } from 'react';
import "../../../css/UserTravelDocumentInfoCard.scss"
import { travelDocumentStatus } from '../../../utils/const';

const UserTravelDocumentInfoCard = (props) => {

    const [selectedDocument, setSelectedDocument] = useState()
    const [snackbarData, setSnackbarData] = useState({ open: false, message: "", severity: "", onClose: null })
    const [isLoading, setIsLoading] = useState(true);
    const [imageSrc, setImageSrc] = useState("");
    const [imageName, setImageName] = useState("");
    const [isImageLoading, setIsImageLoading] = useState(false);
    const { handleFileRequest } = useHttp()

    useEffect(() => {
        // select travel document popup
        if (!props.selectedDocument && props.id) {
            // fetchTravelDocumentInfo()
        }
        // travel document list card view
        else {
            setSelectedDocument(props.selectedDocument)
            setIsLoading(false)
            fetchTravelDocumentImage(props.selectedDocument.id)
        }

    }, [props.selectedDocument, props.id])

    const fetchTravelDocumentImage = useCallback(async (documentId) => {
        setIsImageLoading(true)

        let url = getEmployeeOwnTravelDocumentImage.replace("$id", documentId)
        handleFileRequest(url, "GET", null, (data) => {
            if (data.blobContent) {
                setImageSrc(imageContentToImage(data.blobContent))
                setImageName("Travel Document Image")
                setIsImageLoading(false)
            }
            else {
                setImageName("No image available")
                setImageSrc(no_image_availiable)
                setIsImageLoading(false)
            }
        }, (error) => {
            setSnackbarData({ message: error, open: true, severity: "error", onClose: onCloseSnackbar })
        })
    }, [props.selectedDocument])

    const getDocumentStatus = () => {
        var documentExpiryDate = adjustForTimezone(new Date(selectedDocument.expiryDate))
        var currentDate = new Date()

        if (!selectedDocument.expiryDate) {
            return <span className='Status-chip'
                style={{
                    backgroundColor: wso2Theme.palette.status.completed,
                    color: wso2Theme.palette.colors.white
                }}>
                {travelDocumentStatus.ACTIVE}
            </span>
        }

        return <span className='Status-chip'
            style={{
                backgroundColor: getTravelDocumentStatusColor(getDateForDB(currentDate) <= getDateForDB(documentExpiryDate)),
                color: wso2Theme.palette.colors.white
            }}>
            {(getDateForDB(currentDate) <= getDateForDB(documentExpiryDate)) ? travelDocumentStatus.ACTIVE : travelDocumentStatus.EXPIRED}
        </span>
    }

    const onCloseSnackbar = () => {
        setSnackbarData({ ...snackbarData, open: false })
    }

    // const handleCloseEditTravelDocumentDialog = () => {
    //     setEditTravelDocumentDialog(false)
    // }

    return (
        <React.Fragment>

            <CustomSnackbar snackbar={snackbarData} />

            <BackdropProgress open={isLoading}/>

            <div className='User-travel-document-info-cards'>
                {!isLoading && (
                    <Paper className='Details-paper Border-elevation'>
                        <div className='Document-info-title'>
                            <span>Document Details</span>
                            {/* {isAccessGranted([PRIVILEGES.EDIT_TRAVEL_DOCUMENT]) && <span className='Edit-document-span'><Button variant={"contained"} startIcon={<EditIcon />} color="secondary" className='Edit-document-button'
                                            onClick={()=>editDocument()} disabled={isImageLoading}>Edit Document</Button></span>} */}
                        </div>
                        <Grid container className='Document-info-entry'>
                            <Grid item lg={5} className='Document-info-span'>Document Number : </Grid>
                            <Grid item lg={7}>{selectedDocument.documentNo}</Grid>
                        </Grid>
                        <Grid container className='Document-info-entry'>
                            <Grid item lg={5} className='Document-info-span'>Document Type : </Grid>
                            <Grid item lg={7}>{selectedDocument.documentType}</Grid>
                        </Grid>
                        <Grid container className='Document-info-entry'>
                            <Grid item lg={5} className='Document-info-span'>Issued Country : </Grid>
                            <Grid item lg={7}>{getCountryNameFromCountryCode(selectedDocument.issuedCountry) ? getCountryNameFromCountryCode(selectedDocument.issuedCountry) : selectedDocument.country}</Grid>
                        </Grid>
                        <Grid container className='Document-info-entry'>
                            <Grid item lg={5} className='Document-info-span'>Issued Date : </Grid>
                            <Grid item lg={7}>{getDateForDB(adjustForTimezone(new Date(selectedDocument.issuedDate)))}</Grid>
                        </Grid>
                        <Grid container className='Document-info-entry'>
                            <Grid item lg={5} className='Document-info-span'>Expiry Date : </Grid>
                            <Grid item lg={7}>{selectedDocument.expiryDate?getDateForDB(adjustForTimezone(new Date(selectedDocument.expiryDate))):"No expiry date"}</Grid>
                        </Grid>
                        {props.selectedDocument && (
                            <Grid container className='Document-info-entry'>
                                <Grid item lg={5} className='Document-info-span'>Status : </Grid>
                                <Grid item lg={7}>{getDocumentStatus()}</Grid>
                            </Grid>
                        )}
                        <div className={props.id ? 'Document-image-div-for-popup' : 'Document-image-div-for-card'}>
                            {isImageLoading ? <CircularProgress className='Secondary-loader' color="secondary" /> : <img id="image" src={imageSrc} alt={imageName} className='Document-image' />}
                        </div>
                    </Paper>
                )}
            </div>

        </React.Fragment>
    );
}

export default UserTravelDocumentInfoCard;